import { createI18n } from 'vue-i18n';
import de from './locales/de.json';
import en from './locales/en.json';
import es from './locales/es.json';
import fr from './locales/fr.json';
import it from './locales/it.json';
import ja from './locales/ja.json';
import ko from './locales/ko.json';
import nl from './locales/nl.json';
import pt from './locales/pt.json';
import ru from './locales/ru.json';
import zh from './locales/zh-CN.json';
import zhTW from './locales/zh-TW.json';

const messages = {
  en,
  'zh-CN': zh,
  'zh-TW': zhTW,
  ja,
  ko,
  de,
  fr,
  es,
  pt,
  it,
  ru,
  nl,
};

function resolveLocale(): string {
  const langs = navigator.languages?.length
    ? navigator.languages
    : [navigator.language || 'en'];
  for (const raw of langs) {
    const tag = raw.toLowerCase();
    if (tag in messages) return tag;
    if (tag === 'zh-tw' || tag === 'zh-hk' || tag === 'zh-hant' || tag === 'zh-mo') return 'zh-TW';
    if (tag === 'zh-cn' || tag === 'zh-hans' || tag === 'zh-sg') return 'zh-CN';
    if (tag === 'pt-br' || tag === 'pt-pt') return 'pt';
    const base = tag.split('-')[0]!;
    if (base === 'zh') {
      if (tag.includes('tw') || tag.includes('hk') || tag.includes('hant')) return 'zh-TW';
      return 'zh-CN';
    }
    if (base in messages) return base;
  }
  return 'en';
}

export const i18n = createI18n({
  legacy: false,
  locale: resolveLocale(),
  fallbackLocale: 'en',
  messages,
});
